<template lang="pug">
  v-layout(align-start)
    v-flex
      v-row
        v-col(cols='12' md='4')
          v-card.pa-3(width='100vw' outlined)
            h1(align='left') IVA
              v-divider
              v-row(dense)
                v-col(cols='12' md='8')
                  v-text-field(outlined dense v-model='form.descripcion' label='Descripcion')
                v-col(cols='12' md='4')
                  v-text-field(outlined dense v-model='valor' label='Valor %' hint = "Indique el porcentaje de IVA")
            v-data-table.elevation-1(:headers='headers' hide-default-footer style='margin-top: 5px;' dense  item-key='iva' :items='iva' :loading='loading' loading-text='Cargando, por favor espere...')
              template(slot='iva', slot-scope='props2')
              template(v-slot:item.action='{ item }')
                v-tooltip(bottom='')
                  template(v-slot:activator='{ on }')
                    v-icon.mr-2(color='warning' @click='editItem(item)' v-on="on") mdi-pencil
                  | Editar
                v-tooltip(bottom='')
                  template(v-slot:activator='{ on }')
                    v-icon(color='error' @click='deleteItem(item)' v-on="on") mdi-delete
                  | Eliminar
              template(v-slot:no-data='')
                h1 No hay IVA asociado
              v-row(class='d-flex justify-end' dense )
                v-col(cols='12' md='4')
                  v-btn(color='success' small dark @click='save') Agregar
              v-row(class='d-flex justify-end' dense v-if="editedIndex > -1")
                v-col(cols='12' md='1')
                v-col(cols='12' md='5')
                  v-btn(color='error' small dark @click='close') Cancelar
                v-col(cols='12' md='1')
                v-col(cols='12' md='5')
                  v-btn(color='success' small dark @click='save') Editar
          v-col(cols='12' md='12')
            v-card.pa-3(width='100vw' outlined style='margin-top: 2%;')
              v-card-title(style='margin:0 auto')
                h1(class="text-center") Servidor
                  v-divider
              v-layout(align-center, justify-center, row, wrap fill-height)
                v-flex(xs10)
                  v-select(
                    v-model='servidor'
                    dense,
                    outlined,
                    :items="api",
                    label="Conexion a:")
                  v-text-field#api(
                    v-show='servidor === "Personalizado" ',
                    v-model='axios',
                    outlined,
                    dense,
                    label='API',
                    hint='ejemplo: http://localhost:8080')
              v-flex(xs12, style='margin-bottom:20px;margin-top:10px')
                v-layout(align-center, justify-center, row, wrap fill-height)
                  v-btn(
                    color="success",
                    class="my-5 mx-3",
                    dark,
                    @click.native='saveAPI()') Actualizar
        v-col(cols='12' md='3')
          v-card.pa-3(width='100vw' outlined)
            h1(align='left') CORRELATIVO
              v-divider
              v-row(dense)
                v-col(cols='12' md='8')
                  v-text-field(outlined dense v-model='formCorre.correFacturaVenta' number label='Fact. Venta' hint='Este campo acepta solo Números.' :disabled='readVen')
                v-col(cols='12' md='4' )
                  v-icon.mr-2(color='warning' @click='editVent' v-if="readVen") mdi-pencil
              v-row(dense)
                v-col(cols='12' md='8')
                  v-text-field(outlined dense v-model='formCorre.correPedido' number label='Pedido' hint='Este campo acepta solo Números.' :disabled='readPedido')
                v-col(cols='12' md='4' )
                  v-icon.mr-2(color='warning' @click='editPedido' v-if="readPedido") mdi-pencil
              v-row(dense)
                v-col(cols='12' md='8')
                  v-text-field(outlined dense v-model='formCorre.correNotaEntrega' number label='Nota. Entrega' hint='Este campo acepta solo Números.' :disabled='readNot')
                v-col(cols='12' md='4' )
                  v-icon.mr-2(color='warning' @click='editNot' v-if="readNot") mdi-pencil
              v-row(dense)
                v-col(cols='12' md='8')
                  v-text-field(outlined dense v-model='formCorre.correOrdenCompra' number label='Ord. Compra' hint='Este campo acepta solo Números.' :disabled='readOrd')
                v-col(cols='12' md='4' )
                  v-icon.mr-2(color='warning' @click='editOrd' v-if="readOrd") mdi-pencil
              v-row(dense)
                v-col(cols='12' md='8')
                  v-text-field(outlined dense v-model='formCorre.correNotaDebito' number label='Nota. Debito' hint='Este campo acepta solo Números.' :disabled='readNotDeb')
                v-col(cols='12' md='4' )
                  v-icon.mr-2(color='warning' @click='editNotDeb' v-if="readNotDeb") mdi-pencil
              v-row(dense)
                v-col(cols='12' md='8')
                  v-text-field(outlined dense v-model='formCorre.correNotaCredito' number label='Nota. Credito' hint='Este campo acepta solo Números.' :disabled='readNotCre')
                v-col(cols='12' md='4' )
                  v-icon.mr-2(color='warning' @click='editNotCre' v-if="readNotCre") mdi-pencil
              v-row(class='d-flex justify-end' dense v-if="!readVen || !readPedido || !readNot || !readOrd || !readNotDeb || !readNotCre")
                v-col(cols='12' md='1')
                v-col(cols='12' md='5')
                  v-btn(color='error' small dark @click='closeCorre') Cancelar
                v-col(cols='12' md='1')
                v-col(cols='12' md='5')
                  v-btn(color='success' small dark @click='saveCorre') Guardar
        v-col(cols='12' md='5')
          v-card.pa-3(width='100vw' outlined)
            h1(align='left') EMPRESA
              v-divider
              v-row(dense)
                v-col(cols='6' sm='6' md='6')
                  v-text-field(dense outlined v-model='formEmp.nombre' label='Nombre' :disabled='edit')
                v-col(cols='6' sm='6' md='6')
                  v-text-field(dense outlined v-model='formEmp.rif' label='Rif' :disabled='edit')
                v-col(cols='6' sm='6' md='6')
                  v-text-field(
                    dense,
                    outlined,
                    v-model='formEmp.dir',
                    label='Direccion',
                    :disabled='edit',
                    v-uppercase)
                v-col(cols='6' sm='6' md='6')
                  v-text-field(dense outlined v-model='formEmp.telf' v-mask="'(####)###-##-##'" label='Telefono' :disabled='edit')
                v-col(cols='6' sm='6' md='6')
                  v-text-field#webEmpresa(dense outlined v-model='formEmp.paginaWeb' hint='www.ejemplo.com' label='Pagina Web' :disabled='edit')
                v-col(cols='6' sm='6' md='6')
                  v-text-field#correoConfiguracion(dense outlined v-model='formEmp.correo' hint='ejemplo@ejemplo.com' label='Correo Electronico' :disabled='edit')
              v-row(dense)
                v-col(cols='12' sm='12' md='12')
                  img(:src='ruta + img' v-if='img && !formEmp.imagen.imageUrl' style='width:310px;height:auto')
                  img(:src='formEmp.imagen.imageUrl' v-if='formEmp.imagen.imageUrl' style='width:310px;height:auto')
                  v-text-field(style='height: 56px;margin: 0px 0px 10px;' outlined label='Seleccione la imagen' @click='pickFile' v-model='img' prepend-inner-icon='attach_file' :disabled='edit')
                  input(type='file' style='display: none' ref='image' accept='image/*' @change='onFilePicked')
              v-row(dense v-if='edit')
                v-col(cols='12' md='9')
                v-col(cols='12' md='3')
                  v-btn(color='success' small dark @click='editar') Editar
              v-row(dense v-if='!edit')
                v-col(cols='12' md='4')
                v-col(cols='12' md='4')
                  v-btn(color='error' small dark @click='closeEmp') Cancelar
                v-col(cols='12' md='4')
                  v-btn(color='success' small dark @click='saveEmp') Guardar
          v-col(cols='12' md='12')
            v-card.pa-3(width='100vw' outlined style='margin-top: 2%;')
              v-card-title(style='margin:0 auto')
                h1(class="text-center") Maquina Fiscal
                  v-divider
              v-layout(align-center, justify-center, row, wrap fill-height)
                v-flex(xs10)
                  v-text-field(
                    v-model='maquinaFiscal',
                    outlined,
                    dense,
                    label='API',
                    hint='ejemplo: http://localhost:8080')
              v-flex(xs12, style='margin-bottom:20px;margin-top:10px')
                v-layout(align-center, justify-center, row, wrap fill-height)
                  v-btn(
                    color="success",
                    class="my-5 mx-3",
                    dark,
                    @click.native='saveMaquinaFiscal()') Actualizar
        v-col(cols='6')
          v-card(color='white')
            h1(class="text-center") Importar y Exportar data
              v-divider
              v-card-text
                v-col(cols='12')
                  v-card(color='white')
                    v-card-subtitle.title(style='text-align: center; color: black') Exportar
                    v-card-text
                      v-row(dense)
                        v-col(cols='12' xs='12' sm='4' md='4')
                          ProductoE(:FormPadre="productos" @modiLeyPro='leyendaPro')
                        v-col(cols='12' xs='12' sm='4' md='4')
                          ClienteE(:FormPadre="clientes" :origen='origen' @modiLey='leyenda')
                        v-col(cols='12' xs='12' sm='4' md='4')
                          ProveedorE(:FormPadre="proveedores")
                        v-col(cols='12' xs='12' sm='4' md='12' v-if="ley === true")
                          p
                          v-row(dense)
                          v-divider
                          p
                          h2(style='color: black') Leyenda de Cliente
                            v-btn(color='success' class="iz" small dark @click='ley = false')
                              | Ocultar
                          p
                          LeyCli
                        v-col(cols='12' xs='12' sm='4' md='12' v-if="leyPro === true")
                          p
                          v-row(dense)
                          v-divider
                          p
                          h2(style='color: black') Leyenda del Producto
                            v-btn(color='success' class="iz" small dark @click='leyPro = false')
                              | Ocultar
                          p
                          LeyPro
                v-col(cols='12')
                  v-card(color='white')
                    v-card-subtitle.title(style='text-align: center; color: black') Importar
                    v-card-text
                      v-row(dense)
                        v-col(cols='12' xs='12' sm='4' md='1')
                          v-btn(icon='' class="btn-config" @click='dialogSchemaPro = true')
                            v-icon(color="success") mdi-account-cog 
                        v-col(cols='12' xs='12' sm='4' md='5')
                          v-btn(color='success' width='63%' small dark @click='dialogImporPro = true')
                            v-icon(small) mdi-arrow-collapse-down
                            | Productos
                        v-col(cols='12' xs='12' sm='4' md='6')
                          v-btn(color='success' width='55%' small dark @click='dialogImporCli = true')
                            v-icon(small) mdi-arrow-collapse-down
                            | Clientes
                        v-col(cols='12' xs='12' sm='4' md='6')
                          v-btn(color='success' small dark @click='dialogImporEspe = true')
                            v-icon(small) mdi-arrow-collapse-down
                            | Especificaciones
                        v-col(cols='12' xs='12' sm='4' md='6')
                          v-btn(color='success' small dark @click='dialogImporProve = true')
                            v-icon(small) mdi-arrow-collapse-down
                            | Proveedores
                p
          ImportarPro(:dialogImporPro='dialogImporPro' @close='close' @savePro='listarProducto')
          ImportarEspecificacion(:dialogImporEspe='dialogImporEspe' @close='close')
          ImportarCli(:dialogImporCli='dialogImporCli' @close='close' @save='listarCliente')
          ImportarProve(:dialogImporProve='dialogImporProve' @close='close' @saveProve='listarProveedor')
          SchemasPro(:dialogSchemaPro='dialogSchemaPro' @close='close')
</template>

<script>
import Api from '@/services/methods'
import ImportarPro from '../components/modals/ImportarPro'
import ImportarEspecificacion from '../components/modals/ImportarEspecificacion'
import ImportarCli from '../components/modals/ImportarCli'
import ImportarProve from '../components/modals/ImportarProve'
import SchemasPro from '../components/modals/SchemasPro'
import ProductoE from './excel/ProductoE'
import ClienteE from './excel/ClienteE'
import ProveedorE from './excel/ProveedorE'
import LeyCli from './leyend/LeyCli'
import LeyPro from './leyend/LeyPro'
import axios from 'axios'
import { server, port } from '../services/environment'
export default {
  data: () => ({
    loading: true,
    servidor: 'Nube',
    axios: '',
    maquinaFiscal: '',
    headers: [
      { text: 'Descripcion', value: 'descripcion', align: 'center' },
      { text: 'Valor %', value: 'valor', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    dataForExcel: [
      { colA: 'Hello', colB: 'World' },
      { colA: 'Multi-line', colB: 'This is a long' },
      { colA: 'Another', colB: 'Regular cell' }
    ],
    dialogImporPro: false,
    dialogImporEspe: false,
    dialogImporCli: false,
    dialogImporProve: false,
    dialogSchemaPro: false,
    productos: [],
    clientes: [],
    proveedores: [],
    origen: 'config',
    ley: false,
    leyPro: false,
    readVen: true,
    readPedido: true,
    readNot: true,
    readOrd: true,
    readNotDeb: true,
    readNotCre: true,
    edit: true,
    ruta: server + ':' + port,
    img: '',
    iva: [],
    empresa: [],
    valor: 0,
    editedIndex: -1,
    formCorre: {
      correFacturaVenta: 0,
      correPedido: 0,
      correOrdenCompra: 0,
      correNotaEntrega: 0,
      correNotaDebito: 0,
      correNotaCredito: 0,
      _id: ''
    },
    formEmp: {
      rif: '',
      dir: '',
      paginaWeb: '',
      nombre: '',
      correo: '',
      telf: '',
      _id: '',
      imagen: {
        imageName: '',
        imageUrl: '',
        imageFile: ''
      }
    },
    form: {
      descripcion: '',
      valor: 0
    },
    defaultItem: {
      descripcion: '',
      valor: 0
    },
    api: ['Nube', 'Personalizado']
  }),

  components: {
    ImportarPro,
    ImportarEspecificacion,
    ImportarCli,
    ImportarProve,
    SchemasPro,
    ProductoE,
    ClienteE,
    ProveedorE,
    LeyCli,
    LeyPro
  },

  watch: {
    valor: function (val) {
      this.form.valor = 0
      this.form.valor = val / 100
    },
    servidor: function (val) {
      if (this.servidor === 'Nube') {
        this.axios = ''
      }
    },
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    if (this.$store.state.usuario.master) {
      this.master = this.$store.state.usuario.master
    } else {
      this.master = this.$store.state.usuario._id
    }

    if (this.$store.state.api) {
      this.servidor = 'Personalizado'
      this.axios = this.$store.state.api
    }

    this.maquinaFiscal = this.$store.state.ipMaquina

    this.initialize()
  },
  methods: {
    initialize () {
      this.listarProducto()
      this.listarCliente()
      this.listarProveedor()
      this.cargarIVA()
      this.cargarCorrelativos()
      this.cargarEmpresa(this.$store.state.idempresa.idempresa)
    },

    listarProducto () {
      Api.get('/producto/all')
        .then(response => {
          if (response.data.length === 0) {
            response.data.push({
              nombre: '000',
              descripcion: 'Producto Generico',
              idEmpresa: this.$store.state.idempresa.idempresa
            })
            this.productos = response.data
          } else {
            this.productos = response.data
          }
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarCliente () {
      Api.get('/cliente')
        .then(response => {
          if (response.data.length === 0) {
            response.data.push({
              rif: '000',
              nombre: 'Cliente Generico',
              idEmpresa: this.$store.state.idempresa.idempresa
            })
            this.clientes = response.data
          } else {
            this.clientes = response.data
          }
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarProveedor () {
      Api.get('/proveedor')
        .then(response => {
          if (response.data.length === 0) {
            response.data.push({
              rif: '000',
              nombre: 'Proveedor Generico',
              idEmpresa: this.$store.state.idempresa.idempresa
            })
            this.proveedores = response.data
          } else {
            this.proveedores = response.data
          }
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    leyenda () {
      this.ley = true
    },

    leyendaPro () {
      this.leyPro = true
    },

    pickFile () {
      this.$refs.image.click()
    },
    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        let peso = false
        for (let j = 0; j < files.length; j++) {
          if (files[j].size > 4194304) {
            peso = true
          }
        }
        if (peso === false) {
          this.formEmp.imagen.imageName = files[0].name
          if (this.formEmp.imagen.imageName.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.formEmp.imagen.imageUrl = fr.result
            this.formEmp.imagen.imageFile = files[0]
          })
        } else {
          this.$swal.fire(
            'Oops...',
            'Error encontrado, la imagen debe pesar menos de 4MB.',
            'error'
          )
          this.files = []
          this.formEmp.imagen = []
        }
      } else {
        this.formEmp.imagen.imageName = ''
        this.formEmp.imagen.imageFile = ''
        this.formEmp.imagen.imageUrl = ''
      }
    },
    cargarEmpresa (id) {
      Api.get('empresa/' + id)
        .then(response => {
          this.empresa = response.data
          this.formEmp._id = this.empresa._id
          this.formEmp.rif = this.empresa.rif
          this.formEmp.dir = this.empresa.dir
          this.formEmp.paginaWeb = this.empresa.paginaWeb
          this.formEmp.telf = this.empresa.telf
          this.formEmp.nombre = this.empresa.nombre
          this.formEmp.correo = this.empresa.correo
          this.img = this.empresa.logo
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    cargarIVA () {
      Api.get('iva')
        .then(response => {
          this.iva = response.data
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    cargarCorrelativos () {
      Api.get('configuracion')
        .then(response => {
          this.configuracion = response.data
          this.loading = false
          this.formCorre.correFacturaVenta = this.configuracion.correFacturaVenta
          this.formCorre.correPedido = this.configuracion.correPedido
          this.formCorre.correOrdenCompra = this.configuracion.correOrdenCompra
          this.formCorre.correNotaEntrega = this.configuracion.correNotaEntrega
          this.formCorre.correNotaDebito = this.configuracion.correNotaDebito
          this.formCorre.correNotaCredito = this.configuracion.correNotaCredito
          this.formCorre._id = this.configuracion._id
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    editVent () {
      this.readVen = false
    },
    editPedido () {
      this.readPedido = false
    },
    editNot () {
      this.readNot = false
    },
    editOrd () {
      this.readOrd = false
    },
    editNotDeb () {
      this.readNotDeb = false
    },
    editNotCre () {
      this.readNotCre = false
    },
    editar () {
      this.edit = false
    },
    editItem (item, bool) {
      this.editedIndex = this.iva.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.form.descripcion = item.descripcion
      this.valor = item.valor * 100
      this.form._id = item._id
    },

    deleteItem (item) {
      const index = this.iva.indexOf(item)
      this.$swal
        .fire({
          title: '¿Estás seguro?',
          text: 'No podrás revertir esta operación!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, Eliminar!'
        })
        .then(result => {
          this.$swal.fire('Borrado!', 'Su registro fue borrado.', 'success')
          this.iva.splice(index, 1)
          Api.delete('/iva/' + item._id).then(response => {
          })
        })
    },

    /* closeSchema () {
      this.dialogSchemaPro = false
    }, */

    close () {
      this.valor = 0
      this.dialogImporCli = false
      this.dialogImporProve = false
      this.dialogImporEspe = false
      this.dialogImporPro = false
      this.dialogSchemaPro = false
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    closeCorre () {
      this.readVen = true
      this.readPedido = true
      this.readNot = true
      this.readOrd = true
      this.readNotDeb = true
      this.readNotCre = true
    },
    closeEmp () {
      this.edit = true
    },
    saveEmp () {
      const data = new FormData()
      // this.formEmp.master = this.master
      Object.keys(this.formEmp).map(key => {
        if (Array.isArray(this.formEmp[key])) {
          this.formEmp[key].forEach(val => {
            if (typeof val === 'object' && val !== null) {
              return data.append(`${key}[]`, JSON.stringify(val))
            }
            return data.append(`${key}[]`, val)
          })
        } else if (
          typeof this.formEmp[key] === 'object' &&
            this.formEmp[key] !== null
        ) {
          return data.append(key, JSON.stringify(this.formEmp[key]))
        } else {
          return data.append(key, this.formEmp[key])
        }
      })
      if (this.formEmp.imagen.imageFile) {
        data.append('imagen', this.formEmp.imagen.imageFile)
      }
      // data.append('_id', this.formEmp._id)
      Api.put('/empresa', data)
        .then(response => {
          this.$swal({
            icon: 'success',
            title: 'Modificacion exitosa',
            text: 'Todos los cambios han sido efectuados'
          })
          this.$emit('edited', this.form)
          this.closeEmp()
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al modificar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    saveCorre () {
      Api.put('configuracion', this.formCorre)
        .then(response => {
          this.$swal({
            type: 'success',
            title: 'Modificacion exitosa',
            text: 'Todos los cambios han sido efectuados'
          })
          this.closeCorre()
          this.cargarCorrelativos()
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al modificar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    save () {
      if (this.form.descripcion && this.form.valor) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        if (this.editedIndex > -1) {
          Api.put('iva', this.form)
            .then(response => {
              this.$swal({
                type: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.close()
              this.initialize()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modificar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
          Object.assign(this.iva[this.editedIndex], this.form)
        } else {
          Api.post('iva', this.form)
            .then(response => {
              this.$swal({
                type: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.close()
              this.initialize()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        }
      }
    },

    saveMaquinaFiscal () {
      console.log(this.maquinaFiscal)
      this.$store.dispatch('ipMaquina', this.maquinaFiscal)
    },

    saveAPI () {
      if (this.servidor === 'Personalizado') {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => { this.$swal.showLoading() }
        })
        axios.get(`${this.axios}/api/empresa/test`)
          .then(res => {
            this.$swal({
              icon: 'success',
              title: 'Cambio exitoso'
            })
            this.$store.dispatch('api', this.axios)
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al cargar'
                // text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      } else {
        this.$swal({
          icon: 'success',
          title: 'Cambio exitoso'
        })
        this.$store.dispatch('api', '')
      }
    }
  }
}
</script>

<style lang="scss">
.iz {
  margin-left: 5%
}

.btn-config {
  margin-left: 120%;
}
</style>
